import styled from 'styled-components';
import { max, min } from '../../../../../theme/breakpoints';

interface IFeature {
  color?: string;
}

export const FeatureItem = styled.li<IFeature>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0.5rem 0;
`;

type TIsFreeTrial = { isFreeTrialFeature: boolean; color: string | undefined };
export const IconWrapper = styled.div<TIsFreeTrial>`
  flex: 0 0 1rem;
  margin-right: 0.875rem;

  svg path {
    fill: ${({ theme, isFreeTrialFeature, color }) => (!!isFreeTrialFeature ? color : theme.colors.text)};
  }
`;

export const FeatureDescription = styled.p<TIsFreeTrial>`
  color: ${({ theme, isFreeTrialFeature, color }) => (!!isFreeTrialFeature ? color : theme.colors.text)};
  font-family: ${({ theme, isFreeTrialFeature }) =>
    !!isFreeTrialFeature ? theme.fonts.primary.bold : theme.fonts.primary.regular};
  font-size: 1.125rem;
  line-height: 1.25rem;
  margin: 0;
  text-align: left;

  > span {
    color: ${({ color }) => color};
  }
  @media screen and ${max('largeDesktop')} {
    font-size: 0.975rem;
  }
`;

export const LearnMoreLink = styled.a`
  font-family: ${({ theme }) => theme.fonts.primary.regular};
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.text};
  font-size: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 1rem;
  white-space: nowrap;
  transition: 0.2s all ease-in-out;

  @media screen and ${min('largeTablet')} {
    &:hover {
      opacity: 0.5;
    }
  }
  @media screen and ${max('largeDesktop')} {
    font-size: 0.85rem;
  }
`;
